import React from "react";

interface InputProps {
  value?: string;
  placeholder?: string;
  type: string;
  onChange?: (event: any) => void;
}

export default function Input({
  value,
  onChange,
  placeholder,
  type = "text",
}: InputProps) {
  switch (type) {
    case "text":
      return (
        <input
          type={type}
          placeholder={placeholder}
          className="text-left w-full bg-transparent outline-none text-4xl text-white text-opacity-70"
          value={value}
          onChange={onChange}
        />
      );
    case "number":
      return (
        <input
          type={type}
          placeholder={placeholder}
          className="text-left w-full bg-transparent outline-none text-4xl max-sm:text-xl text-white text-opacity-70"
          value={value}
          onChange={onChange}
        />
      );
    case "range":
      return (
        <input
          id="large-range"
          type={type}
          value={value}
          className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer range-lg dark:bg-gray-700"
          onChange={onChange}
        />
      );
    default:
      return (
        <input
          type={type}
          placeholder={placeholder}
          className="text-left w-full bg-transparent outline-none text-4xl text-white text-opacity-30"
          value={value}
          onChange={onChange}
        />
      );
  }
}
